import { render, staticRenderFns } from "./OtherTeamPointLabelArea.vue?vue&type=template&id=e5ba8d12&scoped=true&"
import script from "./OtherTeamPointLabelArea.vue?vue&type=script&lang=js&"
export * from "./OtherTeamPointLabelArea.vue?vue&type=script&lang=js&"
import style0 from "./OtherTeamPointLabelArea.vue?vue&type=style&index=0&id=e5ba8d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ba8d12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
